import { render, staticRenderFns } from "./SushiServiceSection.vue?vue&type=template&id=01678c90&scoped=true"
import script from "./SushiServiceSection.vue?vue&type=script&lang=js"
export * from "./SushiServiceSection.vue?vue&type=script&lang=js"
import style0 from "./SushiServiceSection.vue?vue&type=style&index=0&id=01678c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01678c90",
  null
  
)

export default component.exports